import { Spaceoq5xo9lsieqc as Space } from './Space.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  NativeElement2p8z5z0r9meck as NativeElement,
  get_native16zxqjg6lrtlz as get_native,
  Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref,
} from '../NativeElement.commonHtml.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  get_entries3nqgftw5r4i02 as get_entries,
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_0,
} from '../../models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_overlayFrame1s8kw8rhusiwv as get_overlayFrame } from '../l2/appBase.mjs';
import { get_atTopEnd2f4khbhwy0qa as get_atTopEnd } from '../helpers.mjs';
import { Button263cw152yl80e as Button } from './Button.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from './IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from './Button.mjs';
import {
  popoverWriter2910ws87tq4dw as popoverWriter,
  keepPopoverOpen28p29d3izy3mk as keepPopoverOpen,
  get_popoverKeepOpenyttrvw1n7ako as get_popoverKeepOpen,
  closeSiblingPopovers3i0hc71zpkpil as closeSiblingPopovers,
} from '../ViewContextExtensions.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './Frame.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { PopoverSemantic_getInstanceyx37zl2h0qnj as PopoverSemantic_getInstance } from '../../models/Theme.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  UInt1hthisrv6cndi as UInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { maxOf1m19db8qhkqy5 as maxOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FloatingInfoHolder$menuGenerator$lambda(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Space())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function FloatingInfoHolder$closeButton$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.close_yn9xrc_k$();
    return Unit_instance;
  }), 0);
}
var FloatingInfoHolder$block$1Class;
function FloatingInfoHolder$block$1() {
  if (FloatingInfoHolder$block$1Class === VOID) {
    class $ extends NativeElement() {
      constructor(this$0, $o) {
        super($o.get_context_h02k06_k$());
        this.native_1.tag_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            this$0.close_yn9xrc_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            this$0.close_yn9xrc_k$();
            return Unit_instance;
          };
        }
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.native_1.position = value;
        // Inline function 'com.lightningkite.kiteui.views.left' call
        this.native_1.style_1.native_1.left = '0';
        // Inline function 'com.lightningkite.kiteui.views.right' call
        this.native_1.style_1.native_1.right = '0';
        // Inline function 'com.lightningkite.kiteui.views.bottom' call
        this.native_1.style_1.native_1.bottom = '0';
        // Inline function 'com.lightningkite.kiteui.views.top' call
        this.native_1.style_1.native_1.top = '0';
        // Inline function 'com.lightningkite.kiteui.views.opacity' call
        this.native_1.style_1.native_1.opacity = '0';
        // Inline function 'com.lightningkite.kiteui.views.zIndex' call
        this.native_1.style_1.native_1.zIndex = '998';
        this.native_1.classes_1.add_utx5q5_k$('active-' + Default_getInstance().nextInt_ujorgc_k$());
        this.native_1.setAttribute_j9pxft_k$('role', 'presentation');
        this.native_1.setAttribute_j9pxft_k$('aria-hidden', 'true');
        this$0.blockView_1 = this;
      }
    }
    initMetadataForClass($);
    FloatingInfoHolder$block$1Class = $;
  }
  return FloatingInfoHolder$block$1Class;
}
function open$reposition$bounds(_this__u8e3s4, sourcePosition, gap, size, screen) {
  var tmp;
  if (_this__u8e3s4.horizontal_1) {
    var x = _this__u8e3s4.after_1 ? sourcePosition.right + gap : sourcePosition.left - gap - size.width;
    var tmp_0;
    switch (_this__u8e3s4.align_1.ordinal_1) {
      case 0:
        tmp_0 = new DOMRect(x, sourcePosition.bottom - size.height, size.width, size.height);
        break;
      case 2:
        tmp_0 = new DOMRect(x, sourcePosition.top, size.width, size.height);
        break;
      case 1:
        tmp_0 = new DOMRect(x, get_centerY(sourcePosition) - size.height / 2, size.width, size.height);
        break;
      case 3:
        tmp_0 = new DOMRect(x, 0.0, size.width, screen.height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  } else {
    var y = _this__u8e3s4.after_1 ? sourcePosition.bottom + gap : sourcePosition.top - gap - size.height;
    var tmp_1;
    switch (_this__u8e3s4.align_1.ordinal_1) {
      case 0:
        tmp_1 = new DOMRect(sourcePosition.right - size.width, y, size.width, size.height);
        break;
      case 2:
        tmp_1 = new DOMRect(sourcePosition.left, y, size.width, size.height);
        break;
      case 1:
        tmp_1 = new DOMRect(get_centerX(sourcePosition) - size.width / 2, y, size.width, size.height);
        break;
      case 3:
        tmp_1 = new DOMRect(0.0, y, screen.width, size.height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function FloatingInfoHolder$open$lambda() {
  return Unit_instance;
}
function open$reposition(this$0, $this_frame, tx, ty, txm, tym) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = $this_frame.native_1;
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver instanceof HTMLElement))
      THROW_CCE();
    var tmp0_elvis_lhs = this$0.anchor_1;
    var sourcePosition = ensureNotNull(get_native(tmp0_elvis_lhs == null ? this$0.source_1 : tmp0_elvis_lhs).element_1).getBoundingClientRect();
    var screen = ensureNotNull(document.body).getBoundingClientRect();
    var size = tmp0_safe_receiver.getBoundingClientRect();
    tmp0_safe_receiver.style.removeProperty('top');
    tmp0_safe_receiver.style.removeProperty('left');
    tmp0_safe_receiver.style.removeProperty('right');
    tmp0_safe_receiver.style.removeProperty('bottom');
    tmp0_safe_receiver.style.removeProperty('transform');
    var gap = 0;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    this_1.add_utx5q5_k$(this$0.preferredDirection_1);
    var _iterator__ex2g4s = get_entries().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var otherAlign = _iterator__ex2g4s.next_20eer_k$();
      this_1.add_utx5q5_k$(this$0.preferredDirection_1.copy$default_jo50x_k$(VOID, VOID, otherAlign));
    }
    var _iterator__ex2g4s_0 = plus(listOf(this$0.preferredDirection_1.align_1), get_entries()).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var otherAlign_0 = _iterator__ex2g4s_0.next_20eer_k$();
      this_1.add_utx5q5_k$(this$0.preferredDirection_1.copy$default_jo50x_k$(VOID, !this$0.preferredDirection_1.after_1, otherAlign_0));
    }
    var altAligns = this$0.preferredDirection_1.after_1 ? listOf_0([Align_End_getInstance(), Align_Center_getInstance(), Align_Start_getInstance(), Align_Stretch_getInstance()]) : listOf_0([Align_Start_getInstance(), Align_Center_getInstance(), Align_End_getInstance(), Align_Stretch_getInstance()]);
    var _iterator__ex2g4s_1 = altAligns.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var otherAlign_1 = _iterator__ex2g4s_1.next_20eer_k$();
      this_1.add_utx5q5_k$(this$0.preferredDirection_1.copy_rm27zg_k$(!this$0.preferredDirection_1.horizontal_1, !this$0.preferredDirection_1.after_1, otherAlign_1));
    }
    var tmp0 = this_1.build_nmwvly_k$();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_2 = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s_2.next_20eer_k$();
        var proposed = open$reposition$bounds(element, sourcePosition, gap, size, screen);
        var epsilon = 0.01;
        if (proposed.left >= screen.left - epsilon && proposed.right <= screen.right + epsilon && proposed.top >= screen.top - epsilon && proposed.bottom <= screen.bottom + epsilon) {
          tmp$ret$7 = element;
          break $l$block;
        }
      }
      tmp$ret$7 = null;
    }
    var currentDirection = tmp$ret$7;
    if (currentDirection == null) {
      this$0.closeButton_ixil6b_k$();
      tmp0_safe_receiver.style.left = '0px';
      tmp0_safe_receiver.style.right = '0px';
      tmp0_safe_receiver.style.bottom = '0px';
      tmp0_safe_receiver.style.top = '0px';
      tx._v = 0.0;
      ty._v = 0.0;
      txm._v = 0;
      tym._v = 0;
    } else if (currentDirection.horizontal_1) {
      if (currentDirection.after_1) {
        tx._v = sourcePosition.right;
        txm._v = 0;
      } else {
        tx._v = sourcePosition.left;
        txm._v = -100;
      }
      switch (currentDirection.align_1.ordinal_1) {
        case 0:
          ty._v = sourcePosition.bottom;
          tym._v = -100;
          break;
        case 2:
          ty._v = sourcePosition.top;
          tym._v = 0;
          break;
        case 1:
          ty._v = (sourcePosition.top + sourcePosition.bottom) / 2;
          tym._v = -50;
          break;
        case 3:
          ty._v = 0.0;
          tym._v = 0;
          tmp0_safe_receiver.style.top = '0px';
          tmp0_safe_receiver.style.bottom = '0px';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    } else {
      if (currentDirection.after_1) {
        ty._v = sourcePosition.bottom;
        tym._v = 0;
      } else {
        ty._v = sourcePosition.top;
        tym._v = -100;
      }
      switch (currentDirection.align_1.ordinal_1) {
        case 0:
          tx._v = sourcePosition.right;
          txm._v = -100;
          break;
        case 2:
          tx._v = sourcePosition.left;
          txm._v = 0;
          break;
        case 1:
          tx._v = (sourcePosition.left + sourcePosition.right) / 2;
          txm._v = -50;
          break;
        case 3:
          tx._v = 0.0;
          txm._v = 0;
          tmp0_safe_receiver.style.left = '0px';
          tmp0_safe_receiver.style.right = '0px';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    tmp0_safe_receiver.style.transform = 'translate(' + tx._v + 'px, ' + ty._v + 'px) translate(' + txm._v + '%, ' + tym._v + '%)';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      if (!(it instanceof HTMLElement))
        THROW_CCE();
      var tmp0_elvis_lhs = this$0.anchor_1;
      var sourcePosition = ensureNotNull(get_native(tmp0_elvis_lhs == null ? this$0.source_1 : tmp0_elvis_lhs).element_1).getBoundingClientRect();
      var screen = ensureNotNull(document.body).getBoundingClientRect();
      var size = it.getBoundingClientRect();
      it.style.removeProperty('top');
      it.style.removeProperty('left');
      it.style.removeProperty('right');
      it.style.removeProperty('bottom');
      it.style.removeProperty('transform');
      var gap = 0;
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      this_0.add_utx5q5_k$(this$0.preferredDirection_1);
      var _iterator__ex2g4s = get_entries().iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var otherAlign = _iterator__ex2g4s.next_20eer_k$();
        this_0.add_utx5q5_k$(this$0.preferredDirection_1.copy$default_jo50x_k$(VOID, VOID, otherAlign));
      }
      var _iterator__ex2g4s_0 = plus(listOf(this$0.preferredDirection_1.align_1), get_entries()).iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var otherAlign_0 = _iterator__ex2g4s_0.next_20eer_k$();
        this_0.add_utx5q5_k$(this$0.preferredDirection_1.copy$default_jo50x_k$(VOID, !this$0.preferredDirection_1.after_1, otherAlign_0));
      }
      var altAligns = this$0.preferredDirection_1.after_1 ? listOf_0([Align_End_getInstance(), Align_Center_getInstance(), Align_Start_getInstance(), Align_Stretch_getInstance()]) : listOf_0([Align_Start_getInstance(), Align_Center_getInstance(), Align_End_getInstance(), Align_Stretch_getInstance()]);
      var _iterator__ex2g4s_1 = altAligns.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var otherAlign_1 = _iterator__ex2g4s_1.next_20eer_k$();
        this_0.add_utx5q5_k$(this$0.preferredDirection_1.copy_rm27zg_k$(!this$0.preferredDirection_1.horizontal_1, !this$0.preferredDirection_1.after_1, otherAlign_1));
      }
      var tmp0 = this_0.build_nmwvly_k$();
      var tmp$ret$14;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_2 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_2.next_20eer_k$();
          var proposed = open$reposition$bounds(element, sourcePosition, gap, size, screen);
          var epsilon = 0.01;
          if (proposed.left >= screen.left - epsilon && proposed.right <= screen.right + epsilon && proposed.top >= screen.top - epsilon && proposed.bottom <= screen.bottom + epsilon) {
            tmp$ret$14 = element;
            break $l$block_0;
          }
        }
        tmp$ret$14 = null;
      }
      var currentDirection = tmp$ret$14;
      if (currentDirection == null) {
        this$0.closeButton_ixil6b_k$();
        it.style.left = '0px';
        it.style.right = '0px';
        it.style.bottom = '0px';
        it.style.top = '0px';
        tx._v = 0.0;
        ty._v = 0.0;
        txm._v = 0;
        tym._v = 0;
      } else if (currentDirection.horizontal_1) {
        if (currentDirection.after_1) {
          tx._v = sourcePosition.right;
          txm._v = 0;
        } else {
          tx._v = sourcePosition.left;
          txm._v = -100;
        }
        switch (currentDirection.align_1.ordinal_1) {
          case 0:
            ty._v = sourcePosition.bottom;
            tym._v = -100;
            break;
          case 2:
            ty._v = sourcePosition.top;
            tym._v = 0;
            break;
          case 1:
            ty._v = (sourcePosition.top + sourcePosition.bottom) / 2;
            tym._v = -50;
            break;
          case 3:
            ty._v = 0.0;
            tym._v = 0;
            it.style.top = '0px';
            it.style.bottom = '0px';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else {
        if (currentDirection.after_1) {
          ty._v = sourcePosition.bottom;
          tym._v = 0;
        } else {
          ty._v = sourcePosition.top;
          tym._v = -100;
        }
        switch (currentDirection.align_1.ordinal_1) {
          case 0:
            tx._v = sourcePosition.right;
            txm._v = -100;
            break;
          case 2:
            tx._v = sourcePosition.left;
            txm._v = 0;
            break;
          case 1:
            tx._v = (sourcePosition.left + sourcePosition.right) / 2;
            txm._v = -50;
            break;
          case 3:
            tx._v = 0.0;
            txm._v = 0;
            it.style.left = '0px';
            it.style.right = '0px';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      it.style.transform = 'translate(' + tx._v + 'px, ' + ty._v + 'px) translate(' + txm._v + '%, ' + tym._v + '%)';
      return Unit_instance;
    });
  }
}
function FloatingInfoHolder$open$slambda($milliseconds, $e) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    var tmp = $e.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var focusable = tmp instanceof HTMLElement ? tmp : null;
    if (!(focusable == null)) {
      focusable.focus();
    } else {
      if ($e.getAttribute('tabindex') == null) {
        $e.setAttribute('tabindex', '-1');
      }
      $e.focus();
    }
    return Unit_instance;
  }), 1);
}
function FloatingInfoHolder$open$lambda$slambda($milliseconds, $e) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    var tmp = $e.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var focusable = tmp instanceof HTMLElement ? tmp : null;
    if (!(focusable == null)) {
      focusable.focus();
    } else {
      if ($e.getAttribute('tabindex') == null) {
        $e.setAttribute('tabindex', '-1');
      }
      $e.focus();
    }
    return Unit_instance;
  }), 1);
}
var FloatingInfoHolderClass;
function FloatingInfoHolder() {
  if (FloatingInfoHolderClass === VOID) {
    class $ {
      constructor(source, anchor) {
        anchor = anchor === VOID ? null : anchor;
        this.source_1 = source;
        this.anchor_1 = anchor;
        this.maxDist_1 = 32;
        this.blockView_1 = null;
        this.closeView_1 = null;
        this.existingView_1 = null;
        this.preferredDirection_1 = Companion_getInstance().belowCenter_1;
        this.currentDirection_1 = this.preferredDirection_1;
        var tmp = this;
        tmp.menuGenerator_1 = FloatingInfoHolder$menuGenerator$lambda;
      }
      closeButton_ixil6b_k$() {
        if (!(this.closeView_1 == null))
          return Unit_instance;
        var o = get_overlayFrame(this.source_1.get_context_h02k06_k$());
        var tmp0_elvis_lhs = this.existingView_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var v = tmp;
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_0 = get_atTopEnd(o);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Button())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        this.closeView_1 = element;
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var icon = Companion_getInstance_0().close_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (IconView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_source_3o5lkf_k$(icon);
        element_0.set_description_s1386w_k$('Close');
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        onClick(element, VOID, VOID, VOID, FloatingInfoHolder$closeButton$slambda(this));
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
      }
      block_337we5_k$() {
        if (!(this.blockView_1 == null))
          return Unit_instance;
        var o = get_overlayFrame(this.source_1.get_context_h02k06_k$());
        var tmp0_elvis_lhs = this.existingView_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var v = tmp;
        var tmp_0 = o.get_children_4cwbp4_k$().indexOf_si1fv9_k$(v);
        o.addChild_51cm2s_k$(tmp_0, new (FloatingInfoHolder$block$1())(this, o));
      }
      open_fm36nu_k$() {
        if (!(this.existingView_1 == null))
          return Unit_instance;
        var removeElementFromOverlay = {_v: FloatingInfoHolder$open$lambda};
        var resizeObserver = {_v: null};
        var tmp = get_overlayFrame(this.source_1.get_context_h02k06_k$());
        var popoverWriter_0 = popoverWriter(this.source_1, tmp, VOID, () => {
          removeElementFromOverlay._v();
          return Unit_instance;
        });
        var startedFocused = equals(get_native(this.source_1).element_1, document.activeElement);
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Frame())(popoverWriter_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        popoverWriter_0.willAddChild_hz2iwc_k$(element);
        var $this$frame = element;
        keepPopoverOpen(this.source_1.get_context_h02k06_k$(), $this$frame);
        if (equals(this.source_1.get_context_h02k06_k$().addons_1, $this$frame.get_context_h02k06_k$().addons_1))
          throw Exception().new_kotlin_Exception_hsqbop_k$('NO NO NO');
        this.currentDirection_1 = this.preferredDirection_1;
        this.existingView_1 = $this$frame;
        $this$frame.set_themeChoice_py59um_k$(PopoverSemantic_getInstance());
        var tmp0 = $this$frame.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.native_1.position = value;
        // Inline function 'com.lightningkite.kiteui.views.zIndex' call
        $this$frame.native_1.style_1.native_1.zIndex = '999';
        // Inline function 'com.lightningkite.kiteui.views.height' call
        $this$frame.native_1.style_1.native_1.height = 'auto';
        // Inline function 'com.lightningkite.kiteui.views.width' call
        $this$frame.native_1.style_1.native_1.width = 'unset';
        // Inline function 'com.lightningkite.kiteui.views.height' call
        $this$frame.native_1.style_1.native_1.height = 'unset';
        $this$frame.native_1.classes_1.add_utx5q5_k$('popover');
        // Inline function 'kotlin.toUInt' call
        var this_0 = Default_getInstance().nextInt_ujorgc_k$();
        var tmp$ret$10 = _UInt___init__impl__l7qpdl(this_0);
        var menuId = 'kiteui-menu-' + new (UInt())(tmp$ret$10);
        $this$frame.native_1.set_id_wyyipr_k$(menuId);
        get_native(this.source_1).setAttribute_j9pxft_k$('aria-controls', menuId);
        $this$frame.native_1.setAttribute_j9pxft_k$('role', 'dialog');
        $this$frame.native_1.setAttribute_j9pxft_k$('aria-modal', 'true');
        get_native(this.source_1).setAttribute_j9pxft_k$('aria-expanded', 'true');
        var tx = {_v: 0.0};
        var txm = {_v: 0};
        var ty = {_v: 0.0};
        var tym = {_v: 0};
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = $this$frame.native_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          if (!(tmp0_safe_receiver instanceof HTMLElement))
            THROW_CCE();
          // Inline function 'kotlin.also' call
          var this_2 = new ResizeObserver((entry, observer) => {
            open$reposition(this, $this$frame, tx, ty, txm, tym);
            return Unit_instance;
          });
          this_2.observe(tmp0_safe_receiver);
          resizeObserver._v = this_2;
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.elementToDo_1.add_utx5q5_k$((it) => {
            if (!(it instanceof HTMLElement))
              THROW_CCE();
            // Inline function 'kotlin.also' call
            var this_0 = new ResizeObserver((entry, observer) => {
              open$reposition(this, $this$frame, tx, ty, txm, tym);
              return Unit_instance;
            });
            this_0.observe(it);
            resizeObserver._v = this_0;
            return Unit_instance;
          });
        }
        this.menuGenerator_1($this$frame);
        $this$frame.native_1.create_md4cuc_k$();
        if (startedFocused) {
          // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
          var this_3 = $this$frame.native_1;
          var tmp0_safe_receiver_0 = this_3.element_1;
          var tmp_1;
          if (tmp0_safe_receiver_0 == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            if (!(tmp0_safe_receiver_0 instanceof HTMLElement))
              THROW_CCE();
            // Inline function 'com.lightningkite.kiteui.afterTimeout' call
            var job = launch($this$frame, VOID, VOID, FloatingInfoHolder$open$slambda(16n, tmp0_safe_receiver_0));
            Job$cancel$ref(job);
            tmp_1 = Unit_instance;
          }
          if (tmp_1 == null) {
            this_3.elementToDo_1.add_utx5q5_k$((it) => {
              if (!(it instanceof HTMLElement))
                THROW_CCE();
              // Inline function 'com.lightningkite.kiteui.afterTimeout' call
              var this_0 = $this$frame;
              var job = launch(this_0, VOID, VOID, FloatingInfoHolder$open$lambda$slambda(16n, it));
              Job$cancel$ref(job);
              return Unit_instance;
            });
          }
        }
        open$reposition(this, $this$frame, tx, ty, txm, tym);
        var repos = (ev) => {
          open$reposition(this, $this$frame, tx, ty, txm, tym);
          return Unit_instance;
        };
        window.addEventListener('scroll', repos, true);
        var escapeHandler = (ev) => {
          var tmp;
          var tmp0_safe_receiver = ev instanceof KeyboardEvent ? ev : null;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.key) === 'Escape') {
            this.close_yn9xrc_k$();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        document.addEventListener('keydown', escapeHandler);
        var mouseMove = (it) => {
          if (!(it instanceof MouseEvent))
            THROW_CCE();
          var tmp;
          if (this.blockView_1 == null && get_popoverKeepOpen($this$frame.get_context_h02k06_k$()) <= 0) {
            var tmp0_elvis_lhs = this.anchor_1;
            var tmp_0 = get_native(tmp0_elvis_lhs == null ? this.source_1 : tmp0_elvis_lhs).element_1;
            var clientRect = (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).getBoundingClientRect();
            var tmp_1 = $this$frame.native_1.element_1;
            var popUpRect = (tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE()).getBoundingClientRect();
            var popUpDist = maxOf(it.x - popUpRect.right, new Float64Array([popUpRect.left - it.x, it.y - popUpRect.bottom, popUpRect.top - it.y]));
            var clientDist = maxOf(it.x - clientRect.right, new Float64Array([clientRect.left - it.x, it.y - clientRect.bottom, clientRect.top - it.y]));
            var tmp_2;
            // Inline function 'kotlin.math.min' call
            if (Math.min(popUpDist, clientDist) > this.maxDist_1) {
              this.close_yn9xrc_k$();
              tmp_2 = Unit_instance;
            }
            tmp = tmp_2;
          }
          return Unit_instance;
        };
        window.addEventListener('mousemove', mouseMove);
        removeElementFromOverlay._v = () => {
          var tmp0_safe_receiver = this.blockView_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            get_overlayFrame(this.source_1.get_context_h02k06_k$()).removeChild_kofmvd_k$(tmp0_safe_receiver);
          }
          this.blockView_1 = null;
          var tmp1_safe_receiver = this.closeView_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            get_overlayFrame(this.source_1.get_context_h02k06_k$()).removeChild_kofmvd_k$(tmp1_safe_receiver);
          }
          this.closeView_1 = null;
          window.removeEventListener('scroll', repos, true);
          window.removeEventListener('mousemove', mouseMove);
          document.removeEventListener('keydown', escapeHandler);
          var tmp2_safe_receiver = resizeObserver._v;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.disconnect();
          }
          resizeObserver._v = null;
          get_native(this.source_1).setAttribute_j9pxft_k$('aria-expanded', 'false');
          get_native(this.source_1).setAttribute_j9pxft_k$('aria-controls', null);
          var tmp;
          if (startedFocused) {
            var tmp_0 = get_native(this.source_1).element_1;
            var tmp3_safe_receiver = tmp_0 instanceof HTMLElement ? tmp_0 : null;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.focus();
            }
            tmp = Unit_instance;
          }
          // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
          var this_0 = $this$frame.native_1;
          var tmp0_safe_receiver_0 = this_0.element_1;
          var tmp_1;
          if (tmp0_safe_receiver_0 == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            $this$frame.onShutdown_5jzxq3_k$();
            if (!(tmp0_safe_receiver_0 instanceof HTMLElement))
              THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = window.getComputedStyle(tmp0_safe_receiver_0).getPropertyValue('transition-duration');
            var tmp0_elvis_lhs = Companion_getInstance_1().parseOrNull_fxylda_k$(it);
            var tmp_2;
            var tmp_3 = tmp0_elvis_lhs;
            if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
              // Inline function 'kotlin.time.Companion.seconds' call
              Companion_getInstance_1();
              tmp_2 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }
            // Inline function 'kotlin.let' call
            var it_0 = tmp_2;
            var tmp_4 = window;
            tmp_4.setTimeout(() => {
              get_overlayFrame(this.source_1.get_context_h02k06_k$()).removeChild_kofmvd_k$($this$frame);
              return Unit_instance;
            }, convertToInt(_Duration___get_inWholeMilliseconds__impl__msfiry(it_0)));
            tmp0_safe_receiver_0.style.opacity = '0';
            tmp0_safe_receiver_0.style.setProperty('pointer-events', 'none');
            tmp_1 = Unit_instance;
          }
          if (tmp_1 == null) {
            this_0.elementToDo_1.add_utx5q5_k$((it) => {
              $this$frame.onShutdown_5jzxq3_k$();
              if (!(it instanceof HTMLElement))
                THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_0 = window.getComputedStyle(it).getPropertyValue('transition-duration');
              var tmp0_elvis_lhs = Companion_getInstance_1().parseOrNull_fxylda_k$(it_0);
              var tmp;
              var tmp_0 = tmp0_elvis_lhs;
              if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
                // Inline function 'kotlin.time.Companion.seconds' call
                Companion_getInstance_1();
                tmp = toDuration(0.25, DurationUnit_SECONDS_getInstance());
              } else {
                tmp = tmp0_elvis_lhs;
              }
              // Inline function 'kotlin.let' call
              var it_1 = tmp;
              var tmp_1 = window;
              tmp_1.setTimeout(() => {
                get_overlayFrame(this.source_1.get_context_h02k06_k$()).removeChild_kofmvd_k$($this$frame);
                return Unit_instance;
              }, convertToInt(_Duration___get_inWholeMilliseconds__impl__msfiry(it_1)));
              it.style.opacity = '0';
              it.style.setProperty('pointer-events', 'none');
              return Unit_instance;
            });
          }
          this.existingView_1 = null;
          return Unit_instance;
        };
        element.onStartup_vrxh3i_k$();
        popoverWriter_0.addChild_2qpft2_k$(element);
      }
      close_yn9xrc_k$() {
        closeSiblingPopovers(this.source_1.get_context_h02k06_k$());
      }
    }
    initMetadataForClass($, 'FloatingInfoHolder');
    FloatingInfoHolderClass = $;
  }
  return FloatingInfoHolderClass;
}
function get_centerY(_this__u8e3s4) {
  return (_this__u8e3s4.top + _this__u8e3s4.bottom) / 2;
}
function get_centerX(_this__u8e3s4) {
  return (_this__u8e3s4.left + _this__u8e3s4.right) / 2;
}
function FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80(p0) {
  return constructCallableReference(() => p0.preferredDirection_1, 0, 0, 135, VOID, [p0]);
}
function FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg(p0) {
  return constructCallableReference((p0_0) => {
    p0.preferredDirection_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 136, VOID, [p0]);
}
//region block: exports
export {
  FloatingInfoHolder as FloatingInfoHolder1eisb99cxddo9,
  FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80 as FloatingInfoHolder$_get_preferredDirection_$ref_ex9o803a3n0i7iydqh3,
  FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg as FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg1g7bb804dwert,
};
//endregion

//# sourceMappingURL=FloatingInfoHolder.js.mjs.map
